<template>
	<c-dialog ref="dialog" type="confirm" :title="title" :width="width" :close-btn="false">
		<div class="c-confirm flex">
			<i v-if="iconClass" class="tf" :class="[iconClass]"></i>
			<p v-html="text"></p>
		</div>
			
		<template slot="button">
			<c-button width="72" height="34" size="m" @click="buttonHandle('resolve')">{{buttonName}}</c-button>
			<c-button v-if="cancelButton" width="72" height="34" size="m" color="black" hollow @click="buttonHandle('cancel')">取消</c-button>
		</template>
	</c-dialog>
</template>

<script>
	export default {
		name: 'confirm',

		data() {
			return {
				title: '消息提醒',
				width: 450,
				text: '',
				icon: 'ask',
				buttonName: '确定',
				cancelButton: true
			};
		},

		mounted() {
			this.$refs.dialog.open();
		},

		computed: {
			iconClass() {
				return {
					warn: 'tf-warn',
					ask: 'tf-help'
				}[this.icon];
			}
		},

		methods: {
			buttonHandle(state) {
				this[state] && this[state]();
				this.$refs.dialog.close();
			}
		}
	};
</script>

<style lang="stylus" scoped>
	.c-confirm {
		padding: 40px 36px;
		line-height: 22px;
		font-size: 14px;
		color: #333;
		word-break: break-all;
		
		.tf {
			margin-right: 14px;
			font-size: 30px;
			color: #EB0000;
		}
	}
</style>
